import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import { createWorkWeek } from './WorkWeek';
import { createWorkDay } from './WorkDay';
import { createCustomAgenda } from './CustomAgenda';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { Link, FormControl, Select, MenuItem, Box, Button, ButtonGroup, Autocomplete, TextField, InputLabel, ListItemText, Snackbar, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Tooltip, Chip, Portal } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import ScheduleShiftModal from './Modals/ScheduleShiftModal';
import EditShiftModal from './Modals/EditShiftModal';
import DuplicateShiftModal from './Modals/DuplicateShiftModal';
import AttendanceModal from './Modals/AttendanceModal';
import ReccurrenceModal from './Modals/RecurrenceModal';
import TaskNotesModal from './Modals/TaskNotesModal';
import axios from 'axios';
import { APIURL } from '../../config';
import CloseIcon from '@mui/icons-material/Close';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import LoopIcon from '@mui/icons-material/Loop';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LocationOnIcon from '@mui/icons-material/LocationOn';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import IconButton from '@mui/material/IconButton';
import LoadingSkeleton from './LoadingSkeleton';
import './Scheduler.css';
import { useReactToPrint } from 'react-to-print';
import AddResourceModal from './Modals/AddResourceModal';
import CustomToolbar from './CustomToolbar';
// Replaced deprecated GridLegacy with modern Grid component

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);
const VIEW_STORAGE_KEY = 'daycareSchedulerCurrentView';
const AGENDA_VIEW_STORAGE_KEY = 'daycareSchedulerAgendaView';
const DATE_STORAGE_KEY = 'daycareSchedulerCurrentDate';

const HomeHealthCareScheduler = (props) => {
  const initialCalendarView = (() => {
    if (typeof window === 'undefined') return 'month';
    try {
      return sessionStorage.getItem(VIEW_STORAGE_KEY) || 'month';
    } catch (err) {
      return 'month';
    }
  })();
  const initialAgendaView = (() => {
    if (typeof window === 'undefined') return 'month';
    try {
      const stored = sessionStorage.getItem(AGENDA_VIEW_STORAGE_KEY);
      return stored === 'week' || stored === 'day' || stored === 'month' ? stored : 'month';
    } catch (err) {
      return 'month';
    }
  })();
  const initialCalendarDate = (() => {
    if (typeof window === 'undefined') return new Date();
    try {
      const stored = sessionStorage.getItem(DATE_STORAGE_KEY);
      const parsed = stored ? new Date(stored) : null;
      return parsed && !Number.isNaN(parsed.getTime()) ? parsed : new Date();
    } catch (err) {
      return new Date();
    }
  })();
  const [selectedView, setSelectedView] = useState('open');
  const [isScheduleShiftModalOpen, setIsScheduleShiftModalOpen] = useState(false);
  const [isEditShiftModalOpen, setIsEditShiftModalOpen] = useState(false);
  const [isAttendanceModalOpen, setIsAttendanceModalOpen] = useState(false); // State for Attendance modal
  const [isRecurrenceModalOpen, setIsRecurrenceModalOpen] = useState(false); // State for Recurrence modal
  const [isTaskNotesModalOpen, setIsTaskNotesModalOpen] = useState(false); // State for Task Notes modal
  const [isAddResourceModalOpen, setIsAddResourceModalOpen] = useState(false);
  const [isDuplicateShiftModalOpen, setIsDuplicateShiftModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [currentDayColor, setCurrentDayColor] = useState(() => {
    try {
      const s = props.user.comp_settings.find(setting => setting.feature_id === 80);
      if (s) { const p = JSON.parse(s.feature_value); if (p.currentDayColor) return p.currentDayColor; }
    } catch (e) {}
    return '#eaf6ff';
  });

  const [currentDate, setCurrentDate] = useState(initialCalendarDate);

  const [resources, setResources] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [customers, setCustomers] = useState([]); 
  const [schedules, setSchedules] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [taskTypes, setTaskTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [contacts, setContacts] = useState([]);

  const [selectedResources, setSelectedResources] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [selectedTaskCustomer, setSelectedTaskCustomer] = useState(null);

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTargetEvent, setDeleteTargetEvent] = useState(null);
  const [deleteHasAttendance, setDeleteHasAttendance] = useState(false);

  const [slotScheduleInfo, setSlotScheduleInfo] = useState({});

  const [dataset, setDataset] = useState([]);

  const [openingTime, setOpeningTime] = useState(new Date(1972, 0, 1, 0, 0, 0, 0));
  const [closingTime, setClosingTime] = useState(new Date(1972, 0, 1, 23, 59, 59, 999));
  const [selectedDays, setSelectedDays] = useState([]);

  const [draggedSchedule, setDraggedSchedule] = useState(null);
  const [view, setView] = useState(initialCalendarView);
  const [agendaView, setAgendaView] = useState(initialAgendaView);
  // const [visibleRange, setVisibleRange] = useState({ start: null, end: null, view: initialCalendarView });
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      sessionStorage.setItem(VIEW_STORAGE_KEY, view);
    } catch (err) {
      // ignore storage errors
    }
  }, [view]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (view !== 'agenda') return;
    try {
      sessionStorage.setItem(AGENDA_VIEW_STORAGE_KEY, agendaView);
    } catch (err) {
      // ignore storage errors
    }
  }, [agendaView, view]);

  /*
  // Cache for forms by task type and completion status per schedule+customer
  const [formsCacheByType, setFormsCacheByType] = useState({}); // { [tas_type]: Array<form> }
  const [taskTypeIdCache, setTaskTypeIdCache] = useState(null); // dropdown mapping cache
  const [tasksByScheduleCustomer, setTasksByScheduleCustomer] = useState({}); // { [`${schedule_id}-${cus_id}`]: task }
  
  // Use refs to track current cache values without triggering re-renders
  const formsCacheByTypeRef = useRef(formsCacheByType);
  const tasksByScheduleCustomerRef = useRef(tasksByScheduleCustomer);
  
  useEffect(() => {
    formsCacheByTypeRef.current = formsCacheByType;
  }, [formsCacheByType]);
  
  useEffect(() => {
    tasksByScheduleCustomerRef.current = tasksByScheduleCustomer;
  }, [tasksByScheduleCustomer]);
  */

  const persistCalendarDate = useCallback((dateToStore) => {
    if (typeof window === 'undefined') return;
    try {
      sessionStorage.setItem(DATE_STORAGE_KEY, dateToStore.toISOString());
    } catch (err) {
      // ignore storage errors
    }
  }, []);

  useEffect(() => {
    persistCalendarDate(currentDate);
  }, [currentDate, persistCalendarDate]);
  
  /*
  const completionKey = (scheduleId, customerId) => `${scheduleId}-${customerId}`;
  const handleFormsCompletedUpdate = useCallback(({ scheduleId, customerId, completedForms }) => {
    if (!scheduleId || !customerId) return;
    const key = completionKey(scheduleId, customerId);
    setVisibleFormsByScheduleCustomer((prev) => {
      const previousEntry = prev[key] || {};
      const prevList = Array.isArray(previousEntry.completedForms) ? previousEntry.completedForms : [];
      const normalized = Array.isArray(completedForms) ? [...completedForms] : prevList;
      if (normalized.length === prevList.length && normalized.every((id) => prevList.includes(id))) {
        return prev;
      }
      return {
        ...prev,
        [key]: {
          ...previousEntry,
          completedForms: normalized,
        },
      };
    });
  }, []);
  */

  const isAdmin = props.user.type === 'Admin';
  const isDayCare = props?.user?.comp_settings.filter(setting => setting.feature_id == 105).length > 0;
  const resourceLabelSingle = isDayCare ? 'Location' : 'Resource';
  const resourceLabelPlural = isDayCare ? 'Locations' : 'Resources';
  const ref = useRef();

  const entityLabelSingle = isDayCare ? 'Member' : 'Customer';
  const entityLabelPlural = isDayCare ? 'Members' : 'Customers';

  const sessionsByScheduleId = useMemo(() =>
    sessions.reduce((map, s) => {
      if (!map[s.schedule_id]) map[s.schedule_id] = [];
      map[s.schedule_id].push(s);
      return map;
    }, {}),
  [sessions]);

  const customerMap = useMemo(() =>
    customers.reduce((map, c) => { map[c.cus_id] = c; return map; }, {}),
  [customers]);

  const employeeMap = useMemo(() =>
    employees.reduce((map, e) => { map[e.id] = e; return map; }, {}),
  [employees]);

  const resourceMap = useMemo(() =>
    resources.reduce((map, r) => { map[r.resource_id] = r; return map; }, {}),
  [resources]);

  const handlePrint = useReactToPrint({
    content: () => ref.current,
  });

  const handleOpenScheduleShiftModal = () => {
    setIsScheduleShiftModalOpen(true);
  };

  const handleCloseScheduleShiftModal = () => {
    setIsScheduleShiftModalOpen(false);
  };

  const handleOpenEditShiftModal = () => {
    if(props.user.permissions.EditSession)
      setIsEditShiftModalOpen(true);
  };

  const handleCloseEditShiftModal = () => {
    setIsEditShiftModalOpen(false);
  };

  const handleOpenAttendanceModal = () => {
    setIsAttendanceModalOpen(true);
  };

  const handleCloseAttendanceModal = () => {
    setIsAttendanceModalOpen(false);
  };

  const handleOpenRecurrenceModal = () => {
    setIsRecurrenceModalOpen(true);
  };

  const handleCloseRecurrenceModal = () => {
    setIsRecurrenceModalOpen(false);
  };

  const handleOpenTaskNotesModal = () => {
    setIsTaskNotesModalOpen(true);
  };

  const handleCloseTaskNotesModal = () => {
    setIsTaskNotesModalOpen(false);
  };

  const handleOpenAddResourceModal = () => setIsAddResourceModalOpen(true);
  const handleCloseAddResourceModal = () => setIsAddResourceModalOpen(false);

  const handleNavigate = useCallback((nextDate) => {
    const next = nextDate instanceof Date ? nextDate : new Date(nextDate);
    if (!Number.isNaN(next.getTime())) {
      setCurrentDate(next);
    }
  }, []);

  // track the currently loaded schedule date range
  const [loadedRange, setLoadedRange] = useState({
    start: moment(initialCalendarDate).subtract(1, 'month').startOf('month'),
    end: moment(initialCalendarDate).add(1, 'month').endOf('month')
  });

  const getData = async () => {
    try {
      // fetch schedules for previous, current, and next month
      const startDate = moment(currentDate).subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      const endDate = moment(currentDate).add(1, 'month').endOf('month').format('YYYY-MM-DD');
      const [resources, employees, customers, schedules, taskTypes, locations, contacts] = await Promise.all([
        axios.get(APIURL + '/resources/company/' + props.comp_id),
        axios.get(APIURL + '/employees', { params: { comp_id: props.comp_id } }),
        axios.get(APIURL + '/customers/scheduler', { params: { comp_id: props.comp_id } }),
        axios.get(APIURL + '/master_schedule/company/' + props.comp_id, { params: { startDate, endDate } }),
        axios.get(APIURL + '/dropdowns/dropdownType/taskType', { params: { comp_id: props.comp_id, employeeType: props.user.type } }),
        axios.get(`${APIURL}/location`, { params: { comp_id: props.comp_id } }),
        axios.get(`${APIURL}/contacts?com_id=${props.comp_id}`),
      ]);
      
      setResources(resources.data.filter(resource => resource.resource_is_active === true).sort((a, b) => a.resource_name.localeCompare(b.resource_name)));
      setEmployees(employees.data);
      setCustomers(customers.data);
      setSchedules(schedules.data?.filter(schedule => schedule.resource_id !== null));
      // remember what we've fetched
      setLoadedRange({ start: moment(startDate), end: moment(endDate) });
      setTaskTypes(taskTypes.data);
      setLocations(locations.data);
      setContacts(contacts.data);
      setIsLoading(false);

      // Fetch sessions for initial schedules
      const initialSchedules = schedules.data?.filter(schedule => schedule.resource_id !== null) || [];
      if (initialSchedules.length) {
        const scheduleIds = initialSchedules.map(s => s.schedule_id);
        const sessResp = await axios.post(
          `${APIURL}/sessions/schedule`,
          { scheduleIds }
        );

        console.log(sessResp);
        
        setSessions(sessResp.data);
      } else {
        setSessions([]);
      }
     } catch (error) {
       console.error('Error fetching data:', error);
     }
   }

  const reloadScheduleData = async () => {
    try {
      // fetch schedules for the known loaded range
      const startDate = loadedRange.start.format('YYYY-MM-DD');
      const endDate = loadedRange.end.format('YYYY-MM-DD');
      const resp = await axios.get(
        `${APIURL}/master_schedule/company/${props.comp_id}`,
        { params: { startDate, endDate } }
      );
      const data = resp.data.filter(schedule => schedule.resource_id !== null);
      setSchedules(data);
      // reload sessions for current schedules
      if (data.length) {
        const scheduleIds = data.map(s => s.schedule_id);
        const respSessions = await axios.post(
          `${APIURL}/sessions/schedule`,
          { scheduleIds }
        );
        setSessions(respSessions.data);
      } else {
        setSessions([]);
      }
      // preserve current selection if still in range
      setSelectedSchedule(prev => data.find(s => s.schedule_id === (prev && prev.schedule_id)) || null);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const reloadSessionData = async () => {
    try {
      if (schedules.length) {
        const scheduleIds = schedules.map(s => s.schedule_id);
        const respSessions = await axios.post(
          `${APIURL}/sessions/schedule`,
          { scheduleIds }
        );
        setSessions(respSessions.data);
      } else {
        setSessions([]);
      }
    } catch (error) {
      console.error('Error fetching sessions:', error);
    }
  }
  
  const setData = (filteredSchedules, resource = false) => {
    setDataset(filteredSchedules.map((schedule, index) => ({
      id: index,
      title: schedule.schedule_name,
      start: new Date(schedule.start_time),
      end: new Date(schedule.end_time),
      schedule: schedule,
      tooltip: `${resourceLabelSingle}: ` + resourceMap[schedule.resource_id]?.resource_name,
      resourceId: resource ? schedule.resource_id : undefined,
      isDraggable: schedule.employee_ids.includes(props.user.emp_id) || isAdmin
    })));
  }

  useEffect(() => {
    getData();
    setSelectedView('open');
  }, [props.selectedProgramId]);

  useEffect(() => {
    let filteredSchedules = schedules;
    
    switch (selectedView) {
      case 'resource':
        setData(filteredSchedules, true);
        setSelectedResources([]);
        break;
      case 'employee':
        let employee = employees.filter(employee => employee.id === props.user.emp_id)[0] || employees[0];
        if(employee) {
          filteredSchedules = filteredSchedules.filter(schedule => schedule.employee_ids.includes(employee.id));
          setData(filteredSchedules);
          setSelectedEmployees([employee]);
        }
        break;
      case 'customer':
        let customer = customers[0];
        if(customer) {
          const customerSessions = sessions.filter(session => session.customer_id === customer.cus_id);
          const customerScheduleIds = new Set(customerSessions.map(s => s.schedule_id));
          filteredSchedules = filteredSchedules.filter(schedule => customerScheduleIds.has(schedule.schedule_id));
          setData(filteredSchedules);
          setSelectedCustomers([customer]);
        }
        break;
      case 'open':
        // Show schedules with no employees assigned
        filteredSchedules = filteredSchedules.filter(schedule => !schedule.employee_ids || schedule.employee_ids.length === 0);
        setData(filteredSchedules);
        break;
      default:
        break;
    }
  }, [selectedView]);

  useEffect(() => {
    let filteredSchedules = schedules;
    filteredSchedules = filteredSchedules.filter(schedule => schedule.employee_ids.includes(props.user.emp_id));
    setData(filteredSchedules);
    setSelectedEmployees(employees.filter(employee => employee.id === props.user.emp_id) || [employees[0]]);
  }, [employees]);

  useEffect(() => {
    let filteredSchedules = schedules;
    if (selectedResources.length > 0) {
      filteredSchedules = filteredSchedules.filter(schedule => selectedResources.some(resource => resource.resource_id === schedule.resource_id));
      setData(filteredSchedules);
    }
  }, [selectedResources]);

  useEffect(() => {
    let filteredSchedules = schedules;
    if (selectedEmployees.length > 0) {
      filteredSchedules = filteredSchedules.filter(schedule => selectedEmployees.some(employee => schedule.employee_ids.includes(employee.id)));
      setData(filteredSchedules);
    } else {
      setDataset([]);
    }
  }, [selectedEmployees]);

  useEffect(() => {
    let filteredSchedules = schedules;
    if (selectedCustomers.length > 0) {
      const selectedCusIdSet = new Set(selectedCustomers.map(c => c.cus_id));
      const customerSessions = sessions.filter(session => selectedCusIdSet.has(session.customer_id));
      const customerScheduleIds = new Set(customerSessions.map(s => s.schedule_id));
      filteredSchedules = filteredSchedules.filter(schedule => customerScheduleIds.has(schedule.schedule_id));
      setData(filteredSchedules);
    } else {
      setDataset([]);
    }
  }, [selectedCustomers]);
        
  useEffect(() => {
    if(props.user.comp_settings.find(setting => setting.feature_id === 80)) {
      let schedulerHours = JSON.parse(props.user.comp_settings.find(setting => setting.feature_id === 80).feature_value);
      setOpeningTime(new Date(schedulerHours.openingTime || '1972-01-01T00:00:00.000Z'));
      setClosingTime(new Date(schedulerHours.closingTime || '1972-01-01T23:59:59.999Z'));
      if(schedulerHours?.days) {
        if(schedulerHours.days.length > 0) {
          setSelectedDays(schedulerHours.days);
        }
      }

    }

  }, [props.user]);

  useEffect(() => {
    axios.get(APIURL + '/config/settings', { params: { comp_id: props.comp_id, feature_id: 80 } })
      .then(res => {
        if (res.data?.length > 0) {
          try {
            const parsed = JSON.parse(res.data[0].feature_value);
            if (parsed.currentDayColor) setCurrentDayColor(parsed.currentDayColor);
          } catch (e) {}
        }
      })
      .catch(() => {});
  }, [props.comp_id]);

  useEffect(() => {
    let filteredSchedules = schedules;
    if(selectedView === 'resource') {
      if(selectedResources.length > 0) {
        filteredSchedules = filteredSchedules.filter(schedule => selectedResources.some(resource => resource.resource_id === schedule.resource_id));
        setData(filteredSchedules);
      } else {
        setData(filteredSchedules, true);
      }
    } else if(selectedView === 'employee') {
      if(selectedEmployees.length > 0) {
        filteredSchedules = filteredSchedules.filter(schedule => selectedEmployees.some(employee => schedule.employee_ids.includes(employee.id)));
        setData(filteredSchedules);
      }
    } else if(selectedView === 'customer') {
      if(selectedCustomers.length > 0) {
        const selectedCusIdSet = new Set(selectedCustomers.map(c => c.cus_id));
        const customerSessions = sessions.filter(session => selectedCusIdSet.has(session.customer_id));
        const customerScheduleIds = new Set(customerSessions.map(s => s.schedule_id));
        filteredSchedules = filteredSchedules.filter(schedule => customerScheduleIds.has(schedule.schedule_id));
        setData(filteredSchedules);
      }
    } else if(selectedView === 'open') {
      // Show schedules with no employees assigned
      filteredSchedules = filteredSchedules.filter(schedule => !schedule.employee_ids || schedule.employee_ids.length === 0);
      setData(filteredSchedules);
    }
  }, [schedules, sessions]);

  useEffect(() => {
    if(props.selectedView){
      setSelectedView(props.selectedView);
    }
  }, [props.selectedView]);

  const newResourceOption = {
    resource_id: 'ADD_RESOURCE_OPTION',
    resource_name: `+ Add New ${resourceLabelSingle}`
  };

  const handleResourceChange = (event, newValue) => {
    if (newValue.some(opt => opt.resource_id === 'ADD_RESOURCE_OPTION')) {
      setSelectedResources(newValue.filter(opt => opt.resource_id !== 'ADD_RESOURCE_OPTION'));
      handleOpenAddResourceModal();
      event.target.value = '';
    } else {
      setSelectedResources(newValue);
    }
  };

  const displayViewSelect = () => {
    let options;
    let getOptionLabel;
    let label;
    let onChange;
    let value;
  
    switch (selectedView) {
      case 'resource': {
        let resourceOptions = [...resources, newResourceOption];
        options = resourceOptions;
        getOptionLabel = (option) => option.resource_name;
        label = resourceLabelSingle;
        onChange = handleResourceChange;
        value = selectedResources;
        break;
      }
      case 'employee':
        options = employees;
        getOptionLabel = (option) => option.employee_name;
        label = 'Employee';
        onChange = (event, newValue) => setSelectedEmployees(newValue);
        value = selectedEmployees;
        break;
      case 'customer':
        options = customers;
        getOptionLabel = (option) => option.cus_name;
        label = entityLabelSingle;
        onChange = (event, newValue) => setSelectedCustomers(newValue);
        value = selectedCustomers;
        break;
      case 'open':
        // No autocomplete selection needed for open view
        return null;
      default:
        return null;
    }
  
    return (
      <Autocomplete
        size='small'
        options={options}
        getOptionLabel={getOptionLabel}
        style={{ width: 'auto' }}
        multiple
        renderInput={(params) => <TextField {...params} label={label || resourceLabelPlural} />}
        onChange={onChange}
        renderOption={(props, option) => {
          let key = null;
          if (option.resource_id) {
            key = option.resource_id;
          } else if (option.id) {
            key = option.id;
          } else if (option.cus_id) {
            key = option.cus_id;
          }
          if (option.resource_id === 'ADD_RESOURCE_OPTION') {
            return (
              <li {...props} key={key} style={{ color: '#3fa7d6' }}>
                <ListItemText primary={getOptionLabel(option)} />
              </li>
            )
          }
          return (
            <li {...props} key={key}>
              <ListItemText primary={getOptionLabel(option)} />
            </li>
          )
        }}
        value={value}
        sx={{ width: value && value.length > 0 ? 300 + value.length * 30 : 300, minWidth: 300, mr: 2 }}
      />
    );
  }
  
  const onSelectEvent = (event) => {
    setSelectedSchedule(event.schedule);
    handleOpenEditShiftModal();
  }

  const onSelectSlot = (slotInfo) => {
    if(slotInfo.action === 'select' && moment(slotInfo.start).isSame(slotInfo.end, 'day')) {
      setSlotScheduleInfo({
        startTime: slotInfo.start,
        endTime: slotInfo.end,
        resource: selectedResources.length > 0 ? selectedResources[0] : undefined
      });
      handleOpenScheduleShiftModal();
    }
    
  }

  const addLineBreaks = (text, maxLineLength) => {
    const words = text.split(' ');
    let result = '';
    let line = '';
  
    for (const word of words) {
      if ((line + word).length > maxLineLength) {
        result += line + '\n\t';
        line = word + ' ';
      } else {
        line += word + ' ';
      }
    }
  
    return result + line;
  }
  
  const assignedCustomers = (event) => {
    const scheduledSessions = sessionsByScheduleId[event.schedule.schedule_id] || [];
    const assignedCusts = scheduledSessions.map(s => customerMap[s.customer_id]).filter(Boolean);
    const customerNames = assignedCusts.map(customer => customer.cus_name).join('\n\t');
    
    const notes = event.schedule.notes ? addLineBreaks(event.schedule.notes, 40) : '';
  
    return event.title + '\n' + event.tooltip + '\n' + 'Employees: \n\t' + event.schedule.employee_ids.map(employee_id => employeeMap[employee_id]?.employee_name).join('\n\t') + '\n' +
    `Assigned ${entityLabelPlural}: \n\t` + (assignedCusts.length > 0 ? customerNames : 'None') + '\nNotes:' + (notes ? '\n\t' + notes : '');
  }

  /*
  const ensureTaskTypeIdCache = useCallback(async () => {
    if (taskTypeIdCache) return taskTypeIdCache;
    try {
      const res = await axios.get(`${APIURL}/dropdowns/dropdownType/fullTaskType`, { params: { comp_id: props.user.comp_id } });
      setTaskTypeIdCache(res.data);
      return res.data;
    } catch {
      return [];
    }
  }, [taskTypeIdCache, props.user.comp_id]);

  const getFormsForTaskType = useCallback(async (tas_type) => {
    if (formsCacheByType[tas_type]) return formsCacheByType[tas_type];
    try {
      const types = await ensureTaskTypeIdCache();
      const type = (types || []).find((t) => t.EntityValue === tas_type);
      if (!type) return [];
      const formsRes = await axios.get(`${APIURL}/task_form`, { params: { taskType_id: type.ddID, company_id: props.comp_id } });
      const forms = formsRes.data || [];
      setFormsCacheByType((prev) => ({ ...prev, [tas_type]: forms }));
      return forms;
    } catch (e) {
      return [];
    }
  }, [formsCacheByType, ensureTaskTypeIdCache, props.comp_id]);

  const getOrCreateTaskForSession = useCallback(async (schedule, customer) => {
    try {
      const res = await axios.get(`${APIURL}/task/session`, {
        params: {
          tas_type: schedule.task_type,
          tas_title: schedule.schedule_name,
          tas_start_date: moment(schedule.start_time).format('YYYY-MM-DD HH:mm:ss'),
          tas_end_date: moment(schedule.end_time).format('YYYY-MM-DD HH:mm:ss'),
          tas_com_id: props.comp_id,
          cus_id: customer.cus_id
        }
      });
      const task = res.data?.data;
      if (task) {
        const key = completionKey(schedule.schedule_id, customer.cus_id);
        setTasksByScheduleCustomer((prev) => ({ ...prev, [key]: task }));
      }
      return task;
    } catch (e) {
      return null;
    }
  }, [props.comp_id]);
  */

  const onEventDrop = useCallback(async ({ event, start, end, resourceId }) => {
    const originalEvent = { ...event };
    event.start = start;
    event.end = end;

    if(resourceId !== event.resourceId && resourceId) {
      return;
    }

    let updatedSchedule = {
      ...event.schedule,
      date: moment(start).format('YYYY-MM-DD'),
      start_time: start,
      end_time: end
    }

    let schedulesCopy = [...schedules];
    let scheduleIndex = schedulesCopy.findIndex(schedule => schedule.schedule_id === event.schedule.schedule_id);
    schedulesCopy[scheduleIndex] = updatedSchedule;
    setSchedules(schedulesCopy);

    await axios.put(APIURL + '/master_schedule/' + event.schedule.schedule_id, updatedSchedule)
      .then(() => {
        axios.post(APIURL + '/shift_action_log', {
          schedule_id: event.schedule.schedule_id,
          shift_emp_id: null,
          action: 'Shift Edited',
          notes: null,
          action_by: props.user.emp_id,
          company_id: props.comp_id,
        }).catch(err => console.error('Error logging shift action:', err));
      })
      .catch(error => {
        console.error("Failed to update event", error);
        setDataset((currentEvents) => {
          return currentEvents.map(evt => {
            if (evt.id === event.id) {
              return { ...evt, start: originalEvent.start, end: originalEvent.end };
            }
            return evt;
          });
        });
        setSchedules((currentSchedules) => {
          return currentSchedules.map(schedule => {
            if (schedule.schedule_id === event.schedule.schedule_id) {
              return { ...schedule, date: moment(originalEvent.start).format('YYYY-MM-DD'), start_time: originalEvent.start, end_time: originalEvent.end };
            }
            return schedule;
          });
        });
      });
  }, [dataset, schedules]);

  const onEventResize = useCallback(({ event, start, end }) => {
    const originalStart = event.start;
    const originalEnd = event.end;
    event.start = start;
    event.end = end;

    let updatedSchedule = {
      ...event.schedule,
      date: moment(start).format('YYYY-MM-DD'),
      start_time: start,
      end_time: end
    }

    let schedulesCopy = [...schedules];
    let scheduleIndex = schedulesCopy.findIndex(schedule => schedule.schedule_id === event.schedule.schedule_id);
    schedulesCopy[scheduleIndex] = updatedSchedule;
    setSchedules(schedulesCopy);
    
    axios.put(APIURL + '/master_schedule/' + event.schedule.schedule_id, updatedSchedule)
      .then(() => {
        axios.post(APIURL + '/shift_action_log', {
          schedule_id: event.schedule.schedule_id,
          shift_emp_id: null,
          action: 'Shift Edited',
          notes: null,
          action_by: props.user.emp_id,
          company_id: props.comp_id,
        }).catch(err => console.error('Error logging shift action:', err));
      })
      .catch(error => {
        console.error("Failed to update event duration", error);
        setDataset((currentEvents) => {
          return currentEvents.map(evt => {
            if (evt.id === event.id) {
              return { ...evt, start: originalStart, end: originalEnd };
            }
            return evt;
          });
        });
        setSchedules((currentSchedules) => {
          return currentSchedules.map(schedule => {
            if (schedule.schedule_id === event.schedule.schedule_id) {
              return { ...schedule, date: moment(originalStart).format('YYYY-MM-DD'), start_time: originalStart, end_time: originalEnd };
            }
            return schedule;
          });
        });
      });
  }, [dataset, schedules]);

  const dragFromOutsideItem = useCallback(() => {
    return draggedSchedule;
  }, [draggedSchedule]);

  const canDragEvent = useCallback((event) => {
    const isWeekView = view === 'week';
    return event?.isDraggable && view !== 'month' && (!isWeekView || !event?.allDay);
  }, [view]);

  const canResizeEvent = useCallback((event) => {
    if (!event?.isDraggable || view === 'month') {
      return false;
    }

    if (view !== 'week') {
      return true;
    }

    const sameDay = event?.start && event?.end && event.start.getDate() === event.end.getDate() && event.start.getMonth() === event.end.getMonth() && event.start.getFullYear() === event.end.getFullYear();
    return !event?.allDay && sameDay;
  }, [view]);

  const CustomEvent = ({ event, actionsOnly }) => {
    const scheduledSessions = sessionsByScheduleId[event.schedule.schedule_id] || [];
    const assignedCustomers = scheduledSessions.map(s => customerMap[s.customer_id]).filter(Boolean);

    // Shift status color: light green = employee assigned, light yellow = notification sent, light orange = just created
    let color;
    if (event.schedule.employee_ids && event.schedule.employee_ids.length > 0) {
      color = '#c8e6c9'; // light green
    } else if (event.schedule.notification_sent) {
      color = '#fff9c4'; // light yellow
    } else {
      color = '#ffe0b2'; // light orange
    }

    // In agenda view, if actionsOnly is true, render only the action icons (stacked vertically)
    if (view === 'agenda' && actionsOnly === true) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0px' }}>
          {event.isDraggable && (
            <>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedSchedule(event.schedule);
                  handleOpenRecurrenceModal();
                }}
                size="small"
                sx={{ height: 28, width: 28, color: '#444' }}
              >
                <LoopIcon sx={{ fontSize: 20 }} />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedSchedule(event.schedule);
                  handleOpenAttendanceModal();
                }}
                size="small"
                sx={{ height: 28, width: 28, color: '#444' }}
              >
                <PendingActionsIcon sx={{ fontSize: 18 }} />
              </IconButton>
              <IconButton
                onClick={(e) => { e.stopPropagation(); handleEventDelete(e, event); }}
                size="small"
                sx={{ height: 28, width: 28, color: '#444' }}
              >
                <DeleteOutlineIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </>
          )}
        </Box>
      );
    }

    // In agenda view, if actionsOnly is false, render the event content (no action icons)
    if (view === 'agenda' && actionsOnly === false) {
      const locationName = event.schedule.resource_id ? resourceMap[event.schedule.resource_id]?.resource_name : '';

      return (
        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: '1.8', alignItems: 'flex-start', gap: '12px' }}>
          {/* Event Details: title, location, notes */}
          <Box sx={{ flex: '0 0 22%', display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '1.05rem', lineHeight: 1.4 }}>{event.title}</Typography>
            {locationName && (
              <Typography variant="body2" sx={{ color: '#999', fontSize: '0.88rem', lineHeight: 1.4, display: 'flex', alignItems: 'center' }}>
                <LocationOnIcon sx={{ fontSize: 16, mr: '2px' }} /> {locationName}
              </Typography>
            )}
            {event.schedule.notes && (
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', fontSize: '0.88rem', color: '#555', mt: 0.3 }}>{event.schedule.notes}</Typography>
            )}
          </Box>
          {/* Staff Members */}
          <Box sx={{ flex: '0 0 20%', minWidth: 0 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '0.9rem', mb: 0.5 }}>Employees:</Typography>
            {event.schedule.employee_ids.map(employee_id => {
              const emp = employeeMap[employee_id];
              return emp ? (
                <Box key={employee_id} sx={{ display: 'flex', alignItems: 'center', gap: '6px', mb: 0.4 }}>
                  <AccountCircleIcon sx={{ fontSize: 20, color: '#546e7a' }} />
                  <Typography sx={{ fontSize: '0.9rem' }}>{emp.employee_name}</Typography>
                </Box>
              ) : null;
            })}
          </Box>
          {/* Assigned Members */}
          <Box sx={{ flex: '1 1 0', display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '0.9rem', mb: 0.5 }}>{`Assigned ${entityLabelPlural} (confirmed):`}</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px', justifyContent: 'flex-start' }}>
            {assignedCustomers.map(customer => {
              const session = scheduledSessions.find(s => s.customer_id === customer.cus_id && s.schedule_id === event.schedule.schedule_id);
              const checkedIn = !!session?.check_in_time || !!session?.is_complete;
              const clickable = !!session?.check_in_time && customer.cus_status === 'Active';

              // Green = checked in, yellow = not yet checked in
              const chipSx = checkedIn
                ? { bgcolor: '#e8f5e9', borderColor: '#66bb6a' }
                : {};

              return (
                <Chip
                  key={customer.cus_id}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                      <span>{customer.cus_name}</span>
                      {!!session?.is_complete && (
                        <Tooltip title="Forms Completed">
                          <CheckCircleIcon color="success" fontSize="small" style={{ marginLeft: 5 }} />
                        </Tooltip>
                      )}
                    </Box>
                  }
                  size="small"
                  variant="outlined"
                  onClick={clickable && props.user.permissions.AddSessionNote ? (e) => {
                    e.stopPropagation();
                    setSelectedSchedule(event.schedule);
                    setSelectedTaskCustomer(customer);
                    handleOpenTaskNotesModal();
                  } : undefined}
                  sx={{
                    fontSize: '0.85rem',
                    height: 'auto',
                    py: '3px',
                    cursor: clickable ? 'pointer' : 'default',
                    ...chipSx,
                    '& .MuiChip-label': { px: '8px', display: 'flex', alignItems: 'center' },
                  }}
                />
              );
            })}
            </Box>
          </Box>
        </div>
      );
    }

    // Non-agenda views (month, week, day) — original rendering
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: '#fff',
        padding: '2px 4px',
        borderRadius: '2px',
        fontSize: '1rem',
      }}>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row', flexWrap: view !== 'month' ? 'wrap' : 'nowrap', overflow: 'hidden'}}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{event.title}</span>
          <Box sx={{ backgroundColor: color, width: 10, borderLeft: '1px solid #fff', borderRight: '1px solid #fff' }} />
          {event.isDraggable &&
            <Box>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedSchedule(event.schedule);
                  handleOpenRecurrenceModal();
                }}
                size="small"
                style={{
                  height: '24px',
                  width: '24px',
                  marginLeft: 'auto',
                  color: 'rgba(255, 255, 255, 0.8)',
                }}
              >
                <LoopIcon fontSize="small" />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedSchedule(event.schedule);
                  handleOpenAttendanceModal();
                }}
                size="small"
                style={{
                  height: '24px',
                  width: '24px',
                  marginLeft: 'auto',
                  color: 'rgba(255, 255, 255, 0.8)',
                }}
              >
                <PendingActionsIcon fontSize="small" />
              </IconButton>
              <IconButton
                onClick={(e) => { e.stopPropagation(); handleEventDelete(e, event); }}
                size="small"
                style={{
                  height: '24px',
                  width: '24px',
                  marginLeft: 'auto',
                  color: 'rgba(255, 255, 255, 0.8)',
                }}
              >        
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box> 
          }
        </Box>
      </div>
    )
  };

  /*
  // Compute completion only for currently visible events when in agenda view
  // Store forms and completed forms for visible events/customers
  const [visibleFormsByScheduleCustomer, setVisibleFormsByScheduleCustomer] = useState({}); // { [key]: { forms, completedForms } }

  useEffect(() => {
    if (view !== 'agenda') return;
    if (!visibleRange.start || !visibleRange.end) return;
    (async () => {
      try {
        const visEvents = dataset.filter((e) => {
          const s = moment(e.start);
          const en = moment(e.end);
          return s.isSameOrBefore(visibleRange.end, 'day') && en.isSameOrAfter(visibleRange.start, 'day');
        });
        let newVisibleForms = {};
        for (const evt of visEvents) {
          const scheduledSessions = sessions.filter((session) => session.schedule_id === evt.schedule.schedule_id);
          const scheduleCustomers = scheduledSessions.map((session) => session.customer_id);
          const assigned = customers.filter((customer) => scheduleCustomers.includes(customer.cus_id));
          for (const customer of assigned) {
            const key = completionKey(evt.schedule.schedule_id, customer.cus_id);
            // Fetch forms for this schedule/task type using ref to avoid infinite loop
            let forms = formsCacheByTypeRef.current[evt.schedule.task_type];
            if (!forms) {
              const types = await ensureTaskTypeIdCache();
              const type = (types || []).find((t) => t.EntityValue === evt.schedule.task_type);
              if (type) {
                const formsRes = await axios.get(`${APIURL}/task_form`, { params: { taskType_id: type.ddID, company_id: props.comp_id } });
                forms = formsRes.data || [];
                setFormsCacheByType((prev) => ({ ...prev, [evt.schedule.task_type]: forms }));
              } else {
                forms = [];
              }
            }
            // Always reset completedForms for each key
            let completedForms = [];
            let task = tasksByScheduleCustomerRef.current[key];
            if (!task) {
              task = await getOrCreateTaskForSession(evt.schedule, customer);
            }
            if (task && forms && forms.length) {
              for (const form of forms) {
                try {
                  // Always check for correct task and form
                  const res = await axios.get(`${APIURL}/customer_form/task/${task.tas_id}`, { params: { formType: form.form_id } });
                  console.log(res.data);
                  
                  if (Array.isArray(res.data) ? res.data.length > 0 : !!res.data) {
                    completedForms.push(form.form_id);
                  }
                } catch (err) {
                  // Optionally log error for debugging
                  // console.error('Error fetching completed form', err);
                }
              }
            }
            newVisibleForms[key] = { forms, completedForms };
          }
        }
        setVisibleFormsByScheduleCustomer(newVisibleForms);
      } catch (err) {
        // Optionally log error for debugging
        // console.error('Error in completedForms calculation', err);
      }
    })();
  }, [view, visibleRange, dataset, sessions, customers, ensureTaskTypeIdCache, getOrCreateTaskForSession, props.comp_id]);
  */

  const handleEventDelete = (e, event) => {
    e.stopPropagation();

    const scheduleSessions = sessions.filter((session) => session.schedule_id === event.schedule.schedule_id);
    const hasAttendance = scheduleSessions.some((session) => session?.check_in_time != null);
    setDeleteHasAttendance(hasAttendance);
    setDeleteTargetEvent(event);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteTargetEvent(null);
    setDeleteHasAttendance(false);
  };

  const handleConfirmDelete = async (isRecurrence) => {
    if (!deleteTargetEvent) return;
    try {
      await axios.delete(`${APIURL}/master_schedule/${deleteTargetEvent.schedule.schedule_id}`, {
        data: { reccurence: isRecurrence }
      });
      axios.post(APIURL + '/shift_action_log', {
        schedule_id: deleteTargetEvent.schedule.schedule_id,
        shift_emp_id: null,
        action: 'Shift Deleted',
        notes: null,
        action_by: props.user.emp_id,
        company_id: props.comp_id,
      }).catch(err => console.error('Error logging shift action:', err));
      setMessage('Shift deleted successfully');
      setSuccess(true);
      reloadScheduleData();
    } catch (err) {
      setMessage('Error deleting shift');
      setError(true);
    } finally {
      handleCloseDeleteModal();
    }
  };

  const handleAddResource = (newResource) => {
    setResources((prevResources) => [...prevResources, newResource]);
    setIsAddResourceModalOpen(false);
  };

  const nextAgendaView = (shouldSet = true) => {
    let newView;
    switch (agendaView) {
      case 'month':
        newView = 'week';
        break;
      case 'week':
        newView = 'day';
        break;
      case 'day':
        newView = 'month';
        break;
      default:
        newView = 'month';
        break;
    }
    if (shouldSet) {
      setAgendaView(newView);
    }
    return newView;
  }

  const prevAgendaView = (shouldSet = true) => {
    let newView;
    switch (agendaView) {
      case 'month':
        newView = 'day';
        break;
      case 'week':
        newView = 'month';
        break;
      case 'day':
        newView = 'week';
        break;
      default:
        newView = 'month';
        break;
    }
    if (shouldSet) {
      setAgendaView(newView);
    }
    return newView;
  }

  const handleRangeChange = async (range, passedView) => {    
    try {
      let rangeStart, rangeEnd;
      if (Array.isArray(range)) {
        rangeStart = moment(range[0]);
        rangeEnd = moment(range[range.length - 1]);
      } else {
        rangeStart = moment(range.start);
        rangeEnd = moment(range.end);
      }
      const unit = passedView || view; 
      // Track visible range for agenda computations
  // setVisibleRange({ start: rangeStart, end: rangeEnd, view: unit });
      const prevMonthThreshold = moment(loadedRange.start).add(1, 'month');

      if (rangeStart.isBefore(prevMonthThreshold, 'day')) {
        const mStart = moment(loadedRange.start).subtract(1, 'month').startOf('month');
        const mEnd = moment(loadedRange.start).subtract(1, 'month').endOf('month');
        const monthResp = await axios.get(`${APIURL}/master_schedule/company/${props.comp_id}`, { params: { startDate: mStart.format('YYYY-MM-DD'), endDate: mEnd.format('YYYY-MM-DD') } });
        setSchedules(prev => {
          const newItems = monthResp.data.filter(s => !prev.some(p => p.schedule_id === s.schedule_id));
          return [...newItems, ...prev];
        });
        setLoadedRange(r => ({ start: mStart, end: r.end }));

        const newScheduleIds = monthResp.data.map(s => s.schedule_id);
        if (newScheduleIds.length) {
          const sessResp = await axios.post(
            `${APIURL}/sessions/schedule`,
            { scheduleIds: newScheduleIds }
          );
          setSessions(prev => {
            const existingIds = new Set(prev.map(s => s.session_id));
            const newSessions = sessResp.data.filter(s => !existingIds.has(s.session_id));
            return [...newSessions, ...prev];
          });
        }
      }
      const nextMonthThreshold = moment(loadedRange.end).subtract(1, 'month');
      if (rangeEnd.isAfter(nextMonthThreshold, 'day')) {
        const mStart = moment(loadedRange.end).add(1, 'month').startOf('month');
        const mEnd = moment(loadedRange.end).add(1, 'month').endOf('month');
        const monthResp = await axios.get(`${APIURL}/master_schedule/company/${props.comp_id}`, { params: { startDate: mStart.format('YYYY-MM-DD'), endDate: mEnd.format('YYYY-MM-DD') } });
        setSchedules(prev => {
          const newItems = monthResp.data.filter(s => !prev.some(p => p.schedule_id === s.schedule_id));
          return [...prev, ...newItems];
        });
        setLoadedRange(r => ({ start: r.start, end: mEnd }));

        const nextScheduleIds = monthResp.data.map(s => s.schedule_id);
        if (nextScheduleIds.length) {
          const sessRespNext = await axios.post(
            `${APIURL}/sessions/schedule`,
            { scheduleIds: nextScheduleIds }
          );
          setSessions(prev => {
            const existingIds = new Set(prev.map(s => s.session_id));
            const newSessions = sessRespNext.data.filter(s => !existingIds.has(s.session_id));
            return [...prev, ...newSessions];
          });
        }
      }

      if (rangeStart.isBefore(loadedRange.start, 'day')) {
        let prevStart, prevEnd;
        if (unit === 'month') {
          prevStart = moment(loadedRange.start).subtract(1, 'month').startOf('month');
          prevEnd = moment(loadedRange.start).subtract(1, 'month').endOf('month');
        } else if (unit === 'week') {
          prevStart = moment(loadedRange.start).subtract(1, 'week').startOf('week');
          prevEnd = moment(loadedRange.start).subtract(1, 'week').endOf('week');
        } else {
          prevStart = moment(loadedRange.start).subtract(1, 'day');
          prevEnd = moment(loadedRange.start).subtract(1, 'day');
        }
        const resp = await axios.get(`${APIURL}/master_schedule/company/${props.comp_id}`, { params: { startDate: prevStart.format('YYYY-MM-DD'), endDate: prevEnd.format('YYYY-MM-DD') } });
        setSchedules(prev => {
          const newItems = resp.data.filter(s => !prev.some(p => p.schedule_id === s.schedule_id));
          return [...newItems, ...prev];
        });
        setLoadedRange(r => ({ start: prevStart, end: r.end }));

        const unitPrevScheduleIds = resp.data.map(s => s.schedule_id);
        if (unitPrevScheduleIds.length) {
          const sessRespUnit = await axios.post(
            `${APIURL}/sessions/schedule`,
            { scheduleIds: unitPrevScheduleIds }
          );
          setSessions(prev => {
            const existingIds = new Set(prev.map(s => s.session_id));
            const newSessions = sessRespUnit.data.filter(s => !existingIds.has(s.session_id));
            return [...newSessions, ...prev];
          }); 
        }
      }
      if (rangeEnd.isAfter(loadedRange.end, 'day')) {
        let nextStart, nextEnd;
        if (unit === 'month') {
          nextStart = moment(loadedRange.end).add(1, 'month').startOf('month');
          nextEnd = moment(loadedRange.end).add(1, 'month').endOf('month');
        } else if (unit === 'week') {
          nextStart = moment(loadedRange.end).add(1, 'week').startOf('week');
          nextEnd = moment(loadedRange.end).add(1, 'week').endOf('week');
        } else {
          nextStart = moment(loadedRange.end).add(1, 'day');
          nextEnd = moment(loadedRange.end).add(1, 'day');
        }
        const resp = await axios.get(`${APIURL}/master_schedule/company/${props.comp_id}`, { params: { startDate: nextStart.format('YYYY-MM-DD'), endDate: nextEnd.format('YYYY-MM-DD') } });
        setSchedules(prev => {
          const newItems = resp.data.filter(s => !prev.some(p => p.schedule_id === s.schedule_id));
          return [...prev, ...newItems];
        });
        setLoadedRange(r => ({ start: r.start, end: nextEnd }));

        const unitNextScheduleIds = resp.data.map(s => s.schedule_id);
        if (unitNextScheduleIds.length) {
          const sessRespNextUnit = await axios.post(
            `${APIURL}/sessions/schedule`,
            { scheduleIds: unitNextScheduleIds }
          );
          setSessions(prev => {
            const existingIds = new Set(prev.map(s => s.session_id));
            const newSessions = sessRespNextUnit.data.filter(s => !existingIds.has(s.session_id));
            return [...prev, ...newSessions];
          });
        }
      }
    } catch (error) {
      setError(true);
      setMessage('Error loading additional schedule data.');
      console.error('Error in handleRangeChange:', error);
    }
  };

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <style>{`#daycare-provider-calendar .rbc-today { background-color: ${currentDayColor} !important; }`}</style>
      {isLoading ? <LoadingSkeleton /> :
        <Box id="daycare-provider-calendar" sx={{ width: '100%', display: 'flex', flexDirection: 'column', m: "10px" }}>
          <Dialog open={isDeleteModalOpen} onClose={handleCloseDeleteModal}>
            <DialogTitle>Delete Shift</DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                Do you want to delete just this shift or all future occurrences of this shift?
              </Typography>
              {deleteHasAttendance && (
                <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                  Attendance has been marked for this shift. Deleting will also permanently remove all associated attendance records.
                </Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleConfirmDelete(false)}>Delete This Shift</Button>
              <Button color="error" onClick={() => handleConfirmDelete(true)}>Delete All Future Shifts</Button>
              <Button onClick={handleCloseDeleteModal}>Cancel</Button>
            </DialogActions>
          </Dialog>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: "10px",
            }}
          >
            {/* Left-aligned FormControl */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FormControl fullWidth size="small" sx={{ width: '200px', mr: 2 }}>
                <InputLabel id="view-select-label">View</InputLabel>
                <Select
                  value={selectedView}
                  onChange={(e) => setSelectedView(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="resource">{resourceLabelSingle}</MenuItem>
                  <MenuItem value="employee">Employee</MenuItem>
                  <MenuItem value="customer">{entityLabelSingle}</MenuItem>
                  <MenuItem value="open">Open</MenuItem>
                </Select>
              </FormControl>
              {displayViewSelect()}
            </Box>

            {/* Right-aligned ButtonGroup */}
            <ButtonGroup variant="contained" sx={{ mr: "20px" }}>
              <Button onClick={handlePrint}>Print</Button>
              {props.user.permissions.ScheduleSession && <Button onClick={handleOpenScheduleShiftModal}>Schedule Shift</Button>}
            </ButtonGroup>
          </Box>
          <Box ref={ref} sx={{ display: 'flex', justifyContent: 'center', height: ref.current ? '100%' : '100%', maxWidth: '100%', mr: '20px' }}>
            <Box sx={{ height: '100% !important', width: '100% !important' }}>
              <DnDCalendar
                components={{
                  event: (props) => <CustomEvent {...props} />, 
                  toolbar: (props) => <CustomToolbar {...props} nextAgendaView={nextAgendaView} prevAgendaView={prevAgendaView} />,
                }}
                localizer={localizer}
                events={dataset}
                startAccessor="start"
                endAccessor="end"
                tooltipAccessor={(event) => assignedCustomers(event)}
                onSelectEvent={onSelectEvent}
                onSelectSlot={onSelectSlot}
                selectable="ignoreEvents"
                resources={selectedView === 'resource' && selectedResources.length === 0 ? resources : undefined}
                resourceIdAccessor={(r) => r.resource_id}
                resourceTitleAccessor={(r) => r.resource_name}
                min={openingTime}
                max={closingTime}
                views={{
                  month: true,
                  week:  selectedDays.length > 0 ? createWorkWeek(selectedDays) : true,
                  day:  selectedDays.length > 0 ? createWorkDay(selectedDays) : true,
                  agenda: createCustomAgenda(agendaView)
                }}
                handleDragStart={(event) => setDraggedSchedule(event)}
                onDropFromOutside={({ start, end, allDay }) => onEventDrop({event: draggedSchedule, start: start, end: end, resourceId: null})}
                onEventDrop={onEventDrop}
                onEventResize={onEventResize}
                draggableAccessor={canDragEvent}
                resizableAccessor={canResizeEvent}
                dragFromOutsideItem={dragFromOutsideItem}
                resizable
                popup
                view={view}
                onView={(nextView) => setView(nextView)}
                date={currentDate}
                defaultDate={initialCalendarDate}
                onNavigate={handleNavigate}
                formats={{
                  agendaDateFormat: (date) => moment(date).format('dddd, MMM DD'),
                  agendaHeaderFormat: (date) => {
                    if(agendaView === 'month') {
                      return moment(date).format('MMMM YYYY');
                    } else if(agendaView === 'week') {
                      return moment(date).startOf('week').format('MMMM DD') + ' - ' + moment(date).endOf('week').format('DD');
                    } else if(agendaView === 'day') {
                      return moment(date).format('dddd MMM DD');
                    }
                  }
                }}
                messages={{
                  noEventsInRange: agendaView === 'month' ? 'No events this month' : agendaView === 'week' ? 'No events this week' : 'No events today',
                }}
                style={{ minHeight: '550px', height: 'calc(100vh - ' + (props.headerHeight ? props.headerHeight : 170) + 'px)' }}
                onRangeChange={handleRangeChange}
              />
            </Box>
          </Box>
          <ScheduleShiftModal 
            open={isScheduleShiftModalOpen} 
            onClose={handleCloseScheduleShiftModal} 
            resources={resources}
            employees={employees}
            customers={customers}
            taskTypes={taskTypes}
            user={props.user}
            comp_id={props.comp_id}
            reloadScheduleData={reloadScheduleData}
            slotScheduleInfo={slotScheduleInfo}
            onSuccess={(message) => {setSuccess(true); setMessage(message)}}
            onError={(message) => {setError(true); setMessage(message)}}
            isAdmin={isAdmin}
            isDayCare={isDayCare}
            locations={locations}
            contacts={contacts}
            onAddResource={(newResource) => setResources(prev => [...prev, newResource])}
          />
          <EditShiftModal 
            open={isEditShiftModalOpen} 
            onClose={handleCloseEditShiftModal}
            schedule={selectedSchedule}
            customers={customers}
            employees={employees}
            sessions={sessions}
            resources={resources}
            taskTypes={taskTypes}
            reloadSessionData={reloadSessionData}
            reloadScheduleData={reloadScheduleData}
            onSuccess={(message) => {setSuccess(true); setMessage(message)}}
            onError={(message) => {setError(true); setMessage(message)}}
            isAdmin={isAdmin}
            user={props.user}
            isDayCare={isDayCare}
            comp_id={props.comp_id}
            onDuplicate={() => {
              setIsEditShiftModalOpen(false);
              setIsDuplicateShiftModalOpen(true);
            }}
          />
          <DuplicateShiftModal
            open={isDuplicateShiftModalOpen}
            onClose={() => setIsDuplicateShiftModalOpen(false)}
            schedule={selectedSchedule}
            customers={customers}
            employees={employees}
            sessions={sessions}
            resources={resources}
            user={props.user}
            comp_id={props.comp_id}
            reloadScheduleData={reloadScheduleData}
            onSuccess={(message) => {setSuccess(true); setMessage(message)}}
            onError={(message) => {setError(true); setMessage(message)}}
            isDayCare={isDayCare}
          />
          <AttendanceModal
            open={isAttendanceModalOpen}
            onClose={handleCloseAttendanceModal}
            schedule={selectedSchedule}
            sessions={sessions}
            customers={customers}
            taskTypes={taskTypes}
            resources={resources}
            reloadSessionData={reloadSessionData}
            onSuccess={(message) => {setSuccess(true); setMessage(message)}}
            onError={(message) => {setError(true); setMessage(message)}}
            user={props.user}
            comp_id={props.comp_id}
            getActiveSessions={props.getActiveSessions}
          />
          <ReccurrenceModal 
            open={isRecurrenceModalOpen}
            onClose={handleCloseRecurrenceModal}
            schedule={selectedSchedule}
            sessions={sessions}
            onSuccess={(message) => {setSuccess(true); setMessage(message)}}
            onError={(message) => {setError(true); setMessage(message)}}
            reloadScheduleData={reloadScheduleData}
            reloadSessionData={reloadSessionData}
            comp_id={props.comp_id}
            user={props.user}
          />
          <TaskNotesModal
            open={isTaskNotesModalOpen}
            onClose={handleCloseTaskNotesModal}
            schedule={selectedSchedule}
            customer={selectedTaskCustomer}
            sessions={sessions}
            onSuccess={(message) => {setSuccess(true); setMessage(message)}}
            onError={(message) => {setError(true); setMessage(message)}}
            comp_id={props.comp_id}
            user={props.user}
            isAdmin={isAdmin}
            onFormsUpdated={reloadSessionData}
          />
          {isAddResourceModalOpen && (
            <AddResourceModal
              open={isAddResourceModalOpen}
              onClose={handleCloseAddResourceModal}
              locations={locations} // Pass locations prop
              contacts={contacts} // Pass contacts prop
              isDayCare={isDayCare} // Pass isDayCare prop
              onAddResource={handleAddResource} // Pass handler for adding resource
            />
          )}
          <Portal>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={success} autoHideDuration={6000} onClose={()=>{setSuccess(false)}} sx={{ zIndex: 9999 }}>
              <MuiAlert onClose={()=>{setSuccess(false)}} severity="success">
                  {message}
              </MuiAlert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={error} autoHideDuration={6000} onClose={()=>{setError(false)}} sx={{ zIndex: 9999 }}>
                <MuiAlert onClose={()=>{setError(false)}} severity="error">
                    {message}
                </MuiAlert>
            </Snackbar>
          </Portal>
        </Box>
      }
    </Box>
  );
};

export default HomeHealthCareScheduler;
